import { isDevelopment } from '$lib/utils/environmentResolver';

export const createControlCenterUrl = (pod: string) => {
	let link = '';

	if (isDevelopment(pod)) {
		link = `https://app.sit1.alidalabs.com/hubs`;
	} else {
		link = `https://app.${pod}.alida.com/hubs`;
	}

	return link;
};
